module.exports = __webpack_public_path__ + "img/3b55676.png";